import { FC, useState } from 'react';
import { Checkbox } from '@nextgen-web-framework/all';
import { ResultCardComponent } from '../Organisms';
import type { ABOCheckboxCardPropsTypes } from './types/propsTypes';
import styles from './ABOCheckboxCard.module.scss';

export const ABOCheckboxCard: FC<ABOCheckboxCardPropsTypes> = (props: ABOCheckboxCardPropsTypes): JSX.Element => {
  const {
    onABOCheckboxClick,
    className,
    initialCheckBoxVal = false,
    isCheckBoxDisabled = false,
    productData,
    showZeroAsFree = true,
  } = props;
  const [checked, setChecked] = useState(initialCheckBoxVal);

  const checkboxClickHandler = () => {
    setChecked(!checked);
    onABOCheckboxClick(productData?.productId || '');
  };
  return (
    <div className={`${styles['abo-checkbox-container']}  ${className}`}>
      <ResultCardComponent
        {...props}
        isABOCard={true}
        showComponentCollection={{
          showAddToCartButtonComp: false,
          showPVBVComp: true,
          showStockStatusComp: true,
        }}
        className={styles['width-full']}
        showZeroAsFree={showZeroAsFree}
      />
      <Checkbox text={''} checked={checked} onClick={checkboxClickHandler} disabled={isCheckBoxDisabled} />
    </div>
  );
};

export type { ABOCheckboxCardPropsTypes };
